export const USER_TYPES = {
  DRIVER: "driver",
  EXPEDITOR: "Expeditor",
  CLIENT: "Client",
};

export const MESSAGE_STATUS = {
  READ: "read",
  DELIVERED: "delivered",
  SENT: "sent",
};

export const MESSAGE_ITEM_TYPES = {
  DATE_SEPARATOR: "date-separator",
  MESSAGE: "message",
};
